"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TariffsTotalSeats = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const classFunctions_1 = require("../../../../utils/classFunctions");
const FlightSeatCount_1 = require("../../../Flight/List/FlightSeatCount");
const tariffGroupMapper_1 = require("../../../TariffsTable/tariffGroupMapper");
require("./index.scss");
const className = 'tariffs-total-seats';
const TariffsTotalSeats = (props) => {
    const { label, tariffs } = props;
    const { locale } = (0, react_intl_1.useIntl)();
    if (!tariffs)
        return null;
    const fieldsetClassNames = (0, classFunctions_1.getClassNames)(`${className}__fieldset`, [
        label ? 'label' : undefined,
    ]);
    return (react_1.default.createElement("div", { className: className },
        react_1.default.createElement("div", { className: `${className}__content` }, tariffs.map((tariff, index) => {
            var _a;
            const tariffCode = (0, tariffGroupMapper_1.mapTariffGroupIdToCode)(tariff.tariff.id);
            const classNames = (0, classFunctions_1.getClassNames)(`${className}__tariff`, [
                `color-${tariffCode}`,
            ]);
            return (react_1.default.createElement("span", { key: index, title: (_a = tariff.tariff.name[locale]) !== null && _a !== void 0 ? _a : '', className: classNames },
                react_1.default.createElement(FlightSeatCount_1.FlightSeatCount, { value: tariff.count, allowedNegative: true })));
        })),
        react_1.default.createElement("fieldset", { className: fieldsetClassNames }, label && react_1.default.createElement("legend", { className: `${className}__legend` }, label))));
};
exports.TariffsTotalSeats = TariffsTotalSeats;
//# sourceMappingURL=index.js.map